import {Component, OnInit, ViewChild} from '@angular/core';
import {language} from '../../../language/vn';
import {SoVanThuService} from '../../../service/info/service-sovanthu';
import {FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import {first} from 'rxjs/operators';
import {validateEmpty} from '../../../global/custom-validate';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import { Subject} from 'rxjs';
import {StaffsService} from '../../../service/staff/service-staffs';
import {ChucVu} from '../../../models/danhmuc/chucvu';
import {ChucVuService} from '../../../service/danhmuc/service-chucvu';
import {GroupOTherComponent} from '../groupother/groupother.component';
import {GroupInnerComponent} from '../groupother/groupinner.component';
import {SelectMultiComponent} from '../groupother/select.component';
import {Staffs} from '../../../models/staff/staffs';
import {StaffChucVuService} from '../../../service/staff/service-staffchucvu';
import {StaffDepartmentService} from '../../../service/staff/service-staffdepartment';
@Component({
  templateUrl: './edit.component.html'

})export class EditStaffsComponent implements OnInit {
  public language = language;
  public frmGroup: FormGroup;
  public id: number = 0;
  public isEdit: boolean = false;
  public isSuDung: boolean = true;
  public submitValidate = false;
  public onClose: Subject<boolean>;
  public dataChucVu: ChucVu[]=[];
  public slGroupId: string = "slGroupId";
  @ViewChild("sgEditStaffs")
  public selectGroup: GroupInnerComponent;
  @ViewChild("sgDVKiemNhiem")
  public selectDVKiemNhiem: GroupInnerComponent;
  @ViewChild("slChucVuKN")
  public selectCVKN: SelectMultiComponent;
  public defaultValue: string[]=['-1'];
  public defaultDonViKN: string[] = ['-1'];
  public defaultCVKN: number[] = [-1];
  public staffItem: Staffs=new Staffs();
  constructor( public staffsService: StaffsService,
               public formBuilder: FormBuilder,
               public toastr: ToastrService,
               public bsModalService: BsModalService,
               public _bsModalRef: BsModalRef,
               public chucVuService: ChucVuService,
               public staffChucVuService: StaffChucVuService,
               public staffDepartmentService: StaffDepartmentService
  ) {

  }
  ngOnInit(): void {
    this.onClose = new Subject();
    this.frmGroup = new FormGroup({
      id: new FormControl('0'),
      hoDem: new FormControl(),
      ten: new FormControl(),
      suDung: new FormControl('0'),
      biDanh: new FormControl(),
      ngaySinh: new FormControl(),
      gioiTinh: new FormControl(),
      chucVu:  new FormControl(),
      maDonVi: new FormControl(),
      thuTu: new FormControl()


    });
    this.frmGroup = this.formBuilder.group({
      hoDem: ['' , Validators.compose([validateEmpty]) ],
      ten: ['' , Validators.compose([validateEmpty]) ],
      thuTu: ['', Validators.compose([validateEmpty, Validators.pattern('[0-9]*')])],
      biDanh: ['', Validators.nullValidator],
      suDung: ['', Validators.nullValidator],
      ngaySinh: ['', Validators.nullValidator],
      gioiTinh: ['', Validators.nullValidator],
      chucVu: ['', Validators.nullValidator],
      maDonVi: ['', Validators.nullValidator],
      id: ['', Validators.nullValidator]
    });
      this.chucVuService.getAll().subscribe(data=> this.dataChucVu= data);

  }


  get f() { return this.frmGroup.controls; }
  edit(id: number) {
    this.id = id;
    this.isEdit = id != 0 ? true: false;
    this.staffsService.getById(id).pipe(first())
      .subscribe(x => {
        this.staffItem = x;
        this.frmGroup.patchValue(x);
        this.defaultValue= [x.maDonVi.toString()];
        this.staffChucVuService.findAllByStaffId(id).subscribe(cv=> this.defaultCVKN= cv.map(p=> p.chucVuID));
        this.staffDepartmentService.findAllByStaffId(id).subscribe(dp=> this.defaultDonViKN = dp.map(d => d.departmentID.toString()));
      });

  }


  createItem ()
  {
    this.frmGroup.controls['suDung'].setValue(this.isSuDung == false ? 0: 1);
    this.frmGroup.value.maDonVi = Number(this.selectGroup.selectTree.value);

    this.staffsService.add(this.frmGroup.value).subscribe({
      next: (data) => {
        let dvkiemNhiem: string = this.selectDVKiemNhiem.selectTree.value.length > 0? this.selectDVKiemNhiem.selectTree.value.join(): '-1';
        this.staffDepartmentService.insertMulti(data.id, dvkiemNhiem).subscribe();
         let cvKiemNhiem: string = this.selectCVKN.selectMulti.value.length>0? this.selectCVKN.selectMulti.value.toString() : '-1';
        this.staffChucVuService.insertMulti(data.id, cvKiemNhiem)    .subscribe();
        this.toastr.success(language.add_success_record, language.message);
        this.onConfirm();
      },
      error: error => {
        this.toastr.error(language.error, language.message);
      }
    });
  }
  updateItem()
  {
    this.frmGroup.value.maDonVi = Number(this.selectGroup.selectTree.value);
    this.frmGroup.value.suDung=this.isSuDung == false ? 0: 1;
    this.staffItem.maDonVi= this.frmGroup.value.maDonVi;
    this.staffItem.chucVu = this.frmGroup.value.chucVu;
    this.staffItem.hoDem = this.frmGroup.value.hoDem;
    this.staffItem.ten = this.frmGroup.value.ten;
    this.staffItem.biDanh = this.frmGroup.value.biDanh;
    this.staffItem.ngaySinh = this.frmGroup.value.ngaySinh;
    this.staffItem.gioiTinh = this.frmGroup.value.gioitinh;
    this.staffItem.thuTu = this.frmGroup.value.thuTu;
    this.staffsService.update(this.staffItem).subscribe({
      next: (data) => {
        let dvkiemNhiem: string = this.selectDVKiemNhiem.selectTree.value.length > 0? this.selectDVKiemNhiem.selectTree.value.join(): '-1';
        this.staffDepartmentService.insertMulti(data.id, dvkiemNhiem).subscribe();
        let cvKiemNhiem: string = this.selectCVKN.selectMulti.value.length>0? this.selectCVKN.selectMulti.value.toString() : '-1';
        this.staffChucVuService.insertMulti(data.id, cvKiemNhiem)    .subscribe();
        this.toastr.success(language.update_success_record, language.message);
        this.onConfirm();

      },
      error: error => {
        this.toastr.error(language.error, language.message);
      }
    });
  }
  onSubmit()
  {
    this.submitValidate = true;
    if(this.frmGroup.invalid)
      return;
    if (this.isEdit)
      this.updateItem();
    else
      this.createItem();
  }
  public onConfirm(): void {

    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public onCancel(): void {
    this.onClose.next(false);
    this._bsModalRef.hide();
  }

  public hideConfirmationModal(): void {
    this.onClose.next(null);
    this._bsModalRef.hide();
  }

}
